<template>
  <div>
    <el-dialog
      :title="noticeData.title"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
    >
      <div>{{ noticeData.content }}</div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="onClickKnow">{{
          $t("lang.我知道了")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  components: {},
  data() {
    return {
      dialogVisible: false,
      noticeData: "",
    };
  },
  created() {
    this.timeDetermination();
  },
  methods: {
    ...mapActions({
      advertisementMessage: "ZD_AdvertisementMessage",
    }),
    async timeDetermination() {
      let res = await this.advertisementMessage({
        systemid: 21,
        vendingtype: 1,
        lan: this.$i18n.locale == "zh-CN" ? "zh" : "en",
      });
      if (res.success !== 1) return;
      if(this.isnull(res.value)) return;
      this.noticeData = res.value;
      let updateTime = new Date(res.value.updateTime).getTime();
      let endTime = new Date(res.value.endTime).getTime();
      let currentTime = new Date().getTime();
      let SevenDays = localStorage.getItem("SevenDays");
      if (SevenDays) {
        if (
          SevenDays > updateTime &&
          SevenDays < endTime &&
          SevenDays < currentTime
        ) {
          this.dialogVisible = true;
        }
      } else if (currentTime > updateTime && currentTime < endTime) {
        this.dialogVisible = true;
      }
    },
    onClickKnow() {
      this.dialogVisible = false;
      localStorage.setItem(
        "SevenDays",
        new Date().getTime() + 60 * 60 * 24 * 7 * 1000
      );
    },
  },
};
</script>

<style scoped lang='less'>
/deep/.el-dialog__body {
  padding: 30px 76px;
  font-size: 18px;
}
</style>